import React from "react";
import BasePicker from "./BasePicker";

export default class OperatorPicker extends BasePicker {

    getUrl() {
        return '/api/operatorpicker'
    }
}
